module.exports = __webpack_public_path__ + "static/img/xy.29995bb9.png";